module.exports = __webpack_public_path__ + "img/transfer27.002a8dde.jpeg";